import { importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { HTTP_INTERCEPTORS, HttpBackend, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Interceptor } from './app/common/services/interceptor.service';
import { LocalStorageService } from '@sb-tools/typescript/services/local-storage.service';
import { UserDataService } from '@sb-tools/typescript/services/user-data.service';
import { WindowRef } from '@sb-tools/typescript/services/window-ref.service';
import { EmojiConfigService } from '@sb-tools/typescript/services/emoji-config.service';
import { HelperService } from '@sb-tools/typescript/services/helper.service';
import { AuthenticationService } from './app/common/services/authentication.service';
import { AttachmentService } from '@sb-tools/typescript/services/attachment.service';
import { SmilesService } from '@sb-tools/typescript/services/smiles.service';
import { CookieService } from '@sb-tools/typescript/authentication/cookie.service';
import { ReplaceEmojisPipe } from '@sb-tools/typescript/pipes/replace-emoji/replace-emojis.pipe';
import { NewLinePipe } from '@sb-tools/typescript/pipes/new-line.pipe';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import packageJson from 'package.json';

function HttpLoaderFactory(http: HttpBackend) {
    return new MultiTranslateHttpLoader(http, [
        { prefix: './assets/i18n/', suffix: '.json?' + packageJson.version },
        { prefix: '/sb-tools/assets/i18n/', suffix: '.json?' + packageJson.version },
        { prefix: '/sb-modules/Frontend-form-field-module/assets/i18n/', suffix: '.json?' + packageJson.version },
        { prefix: '/sb-modules/Frontend-Reply-Templates-Module/assets/i18n/', suffix: '.json?' + packageJson.version },
        { prefix: '/sb-modules/Frontend-User-Avatar-Module/assets/i18n/', suffix: '.json?' + packageJson.version },
    ]);
}

try {
    Office.initialize = () => {
        bootstrapApplication(AppComponent, {
            providers: [
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: Interceptor,
                    multi: true,
                },
                LocalStorageService,
                UserDataService,
                WindowRef,
                EmojiConfigService,
                HelperService,
                AuthenticationService,
                AttachmentService,
                SmilesService,
                CookieService,
                ReplaceEmojisPipe,
                NewLinePipe,
                provideHttpClient(withInterceptorsFromDi()),
                provideAnimations(),
                importProvidersFrom(
                    BsDatepickerModule.forRoot(),
                    ModalModule.forRoot(),
                    TooltipModule.forRoot(),
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useFactory: HttpLoaderFactory,
                            deps: [HttpBackend],
                        },
                    }),
                    SimpleNotificationsModule.forRoot({
                        position: ['bottom', 'right'],
                        timeOut: 3000,
                        lastOnBottom: true,
                        showProgressBar: true,
                        pauseOnHover: true,
                    }),
                ),
            ],
        }).catch((err) => {
            return console.error('error while load module', err);
        });
    };
} catch (error) {
    console.error('oops!', error);
}
